import { FEATURE_FLAGS, useFeatures } from './useFeatures';

const fallback = { enabled: false, accessKey: '', region: 'us', stage: false };

export const useNetDocsStatus = () => {
  const { enabled, settings } = useFeatures(FEATURE_FLAGS.NETDOCS);
  const accessKey = settings.access_key ?? fallback.accessKey;

  return {
    // Preserve legacy behavior: do not show NetDocs UI unless enabled and fully configured.
    enabled: enabled && Boolean(accessKey),
    accessKey,
    region: settings.region ?? fallback.region,
    stage: settings.stage ?? fallback.stage,
  };
};
